@if (show) {
  <div class="container" [style.height.px]="height">
    <div class="inner">
      <mat-spinner [strokeWidth]="3" [diameter]="25"></mat-spinner>
    </div>
  </div>
}